import { render, staticRenderFns } from "./Abouts.vue?vue&type=template&id=b1e44d8a&scoped=true&"
import script from "./Abouts.vue?vue&type=script&lang=js&"
export * from "./Abouts.vue?vue&type=script&lang=js&"
import style0 from "./Abouts.vue?vue&type=style&index=0&id=b1e44d8a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1e44d8a",
  null
  
)

export default component.exports